<ng-container *ngIf="highcharts && chartOptions">
  <eds-proximal
    placement="PerformanceMonthlyTotalReturnsChartProximalTop"
  ></eds-proximal>
  <div edsGrid>
    <div edsRow>
      <div edsCol>
        <highcharts-chart
          *ngIf="highcharts"
          [Highcharts]="highcharts"
          [options]="chartOptions"
          style="width: 100%; height: 400px; display: block"
        ></highcharts-chart>
      </div>
    </div>
  </div>
  <eds-proximal
    placement="PerformanceMonthlyTotalReturnsChartProximalBottom"
  ></eds-proximal>
</ng-container>
